import { Injectable } from '@angular/core'
import { Entity, Group, Metadata, Property } from '../models/common-models'

@Injectable({
  providedIn: 'root',
})
export class EntityService {
  /**
   * Return group for given key if found. Undefined if not found.
   */
  getGroup = (key: string, entity: Entity): Group | undefined => {
    return entity.Groups.find(g => g.Key === key)
  }

  /**
   * Return property for given key if found. Undefined if not found.
   */
  getProperty = (key: string, group: Group): Property | undefined => {
    return group.Properties.find(p => p.Key === key)
  }

  getPropertyFromEntity = (key: string, entity: Entity): Property | undefined => {
    const allProperties: Property[] = []
    entity.Groups.forEach(group => {
      allProperties.push(...group.Properties)
    })

    return allProperties.find(p => p.Key === key)
  }

  getPropertiesFromEntity = (entity: Entity): Property[] => {
    const allProperties: Property[] = []

    entity.Groups.forEach(group => {
      allProperties.push(...group.Properties)
    })

    return allProperties
  }

  /**
   * Return property's Metadata for given key if found. Undefined if not found.
   */
  getMetadata = (property: Property, key: string): Metadata | undefined => {
    return property.Metadata?.find(m => m.Key === key)
  }

  /**
   * Returns Metadata.Value if found. Undefined if not found.
   */
  getMetadataValue = <T>(property: Property, key: string): T | undefined => {
    const metadata = this.getMetadata(property, key)

    return metadata?.Value as T | undefined
  }
}
